import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { AGENT_TYPES } from "../../constants/agentTypes";

const AGENT_LINE_LABEL = {
  [AGENT_TYPES.DOCUMENT]: "Documents",
  [AGENT_TYPES.INTAKE_REVIEW_AGENT]: "Duplicates",
  [AGENT_TYPES.BENEFITS]: "Applications",
  [AGENT_TYPES.APPLICATION_STATUS]: "Applications",
  [AGENT_TYPES.ELIGIBILITY_REVIEW]: "Applications",
};

const DuplicatesLineChart = ({ data, agentName }) => (
  <div className="chart-wrapper">
    <h3>{agentName === AGENT_TYPES.DOCUMENT ? "Rejected Documents by Month" : "Duplicates Processed Per Day"}</h3>

    <ResponsiveContainer width="100%" height="90%">
      <LineChart data={data} margin={{top:10,right:20, left:0,bottom:30}}>
        <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
        <XAxis dataKey="day" interval={0}/>
        <YAxis />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="value"
          name={AGENT_LINE_LABEL[agentName] || "Count"}
          stroke="#E87C24"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
export default DuplicatesLineChart;
